import { isFunction } from "../../utils/functions";
import { TemplateService } from "./template-service";
export function getTemplate(options = {}) {
    let template;
    if (options.visual) {
        options.visual = template = TemplateService.compile(options.visual, options);
    }
    else if (options.template) {
        options.template = template = TemplateService.compile(options.template, options);
    }
    else if (isFunction(options.content)) {
        template = options.content;
    }
    return template;
}
